module.exports = __webpack_public_path__ + "static/img/bg-tr.27b18ab3.webp";